module.exports = __webpack_public_path__ + "static/media/ticket-red.32e3d0c8.svg";